export enum SidePanelTypes {
  QUESTIONS = 'questions',
  VOTES = 'votes',
  ANNOUNCEMENTS = 'announcements',
  ATTACHMENTS = 'attachments',
  DETAILS = 'details',
  PARTICIPANTS = 'participants',
  CHAT = 'chat',
  FEATURE_FLAGS = 'featureFlags',
  SESSION_STATUS = 'sessionStatus'
}